<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">無料トライアルの申し込み</span>
              <span class="breadcrumb-link current">無料トライアルの申し込み（メール送信完了）</span>
            </div>
            <h1 class="hdg02">無料トライアルの申し込み（メール送信完了）</h1>
          </div>
          <div class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">メールの送信が完了いたしました。<br>
              お申し込みは完了しておりません。<br>
              ご入力いただいたメールアドレスへ「無料トライアル登録URL」を送信いたしましたのでご確認ください。</p>
              
              <div class="contact-submit mb40">
                <div class="button contact-submit-button">
                  <a href="/lc/about/" class="txt-blue" target="_blank">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    const group1 = reactive({
    })
    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>

</style>
